// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressHashWithCopy_wrapper__w+Dvl","link":"AddressHashWithCopy_link__doCoi"};